//uat
// export const baseUrl = "https://uathelp.tataplay.com";

//dev
// export const baseUrl = "https://devhelp.tataplay.com";

//prod
export const baseUrl =   "https://help.tataplay.com";
